import { useEffect, useRef } from "react";

export const CALENDLY_URL =
  "https://calendly.com/solcriscione/postulacion-bestias?hide_gdpr_banner=1&hide_event_type_details=1&background_color=1C0F0E&text_color=FDFFFC&primary_color=8A0E20";
const SCRIPT = "https://assets.calendly.com/assets/external/widget.js";
const CSS = "https://assets.calendly.com/assets/external/widget.css";

let loadPromise;

export function loadCalendly() {
  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      if (window.Calendly) return resolve(window.Calendly);
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = CSS;
      document.head.appendChild(link);
      const script = document.createElement("script");
      script.src = SCRIPT;
      script.async = true;
      script.onload = () => resolve(window.Calendly);
      script.onerror = () => reject(new Error("No se pudo cargar Calendly"));
      document.body.appendChild(script);
    });
  }
  return loadPromise;
}

export function openCalendlyPopup() {
  loadCalendly()
    .then((C) => C.initPopupWidget({ url: CALENDLY_URL }))
    .catch((err) => console.error(err));
}

export const CalendlyInline = ({ className = "" }) => {
  const ref = useRef(null);

  useEffect(() => {
    let cancelled = false;
    loadCalendly()
      .then((C) => {
        if (cancelled || !ref.current) return;
        C.initInlineWidget({ url: CALENDLY_URL, parentElement: ref.current });
      })
      .catch((err) => console.error(err));
    return () => {
      cancelled = true;
      if (ref.current) ref.current.replaceChildren();
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="calendly-inline-widget"
      className={`w-full min-w-[320px] ${className}`}
      style={{ minHeight: 640 }}
      aria-label="Calendario de postulación"
    />
  );
};
